const copyContributionLinkToClipboard = ({ contributionId, code, isApplication = false, isEasyBooking = false }) => {
  const dummy = document.createElement('input');
  dummy.style.position = 'absolute';
  dummy.style.left = '-9999px';
  dummy.style.opacity = '0';
  const text = window.location.origin;
  document.body.appendChild(dummy);

  const contributionLabel = contributionId
    ? `/${isApplication ? 'apply-' : ''}contribution-view/${contributionId}`
    : '';
  const codeLabel = code ? `/${code}` : '';

  dummy.value = `${text}${contributionLabel}${codeLabel}/${isEasyBooking ? 'sessions' : 'about'}`;
  dummy.select();
  dummy.setSelectionRange(0, 99999);

  // It is work for premium feature copying
  setTimeout(() => {
    // navigator.clipboard.writeText(dummy.value);
    document.execCommand('copy'); // Alternative used
  }, 150);

  setTimeout(() => {
    document.body.removeChild(dummy);
  }, 300);
};

export default copyContributionLinkToClipboard;
